import React, {Component} from 'react';
import _HauteFire from '../Utils/HauteFire';
import firebase from 'firebase';
import $ from 'jquery';

const HauteFire = new _HauteFire();
const CLIENTID = '473861865114-reblkdvrsa2b9etplbfe2hmfvdmkp3ue.apps.googleusercontent.com';
const APIKEY = 'AIzaSyBCNIlfobAJwMId0FaUjCjU4TuZAbJzhm0';
const SCOPES = 'https://www.googleapis.com/auth/gmail.readonly';

export default class MailList extends Component {
    constructor(props) {
        super(props);

        this.state = {isAuthorized: false, allMessages: []}
    }

    componentDidMount() {
        const _this = this;

        async function getMessagesAndEmails() {
            await _this.getAllMesaages();
            await _this.initGoogleAuth();
        }

        getMessagesAndEmails();
    }

    setAllEmailMessages(allEmailMessages) {
        this.props.setAllEmailMessages(allEmailMessages);
    }

    initGoogleAuth() {
        const _this = this;
        const {messageId} = this.props;
        let inboxMessages = [];

        require("google-client-api")().then((gapi) => {
            gapi.client.setApiKey(APIKEY);
            window.setTimeout(checkAuth, 1);

            function checkAuth() {
                gapi.auth.authorize({
                    client_id: CLIENTID,
                    scope: SCOPES,
                    immediate: true
                }, (authResult) => {
                    if (authResult && !authResult.error) {
                        gapi.client.load('gmail', 'v1', getInbox);
                        // _this.setState({isAuthorized: true});
                    }
                    else {
                        // _this.setState({isAuthorized: false});
                    }
                });
            }

            function getInbox() {
                let requestInbox = gapi.client.gmail.users.messages.list({
                    'userId': 'me',
                    'labelIds': 'SENT'
                });

                requestInbox.execute(function (response) {
                    debugger;
                    $(response.messages).each((index, message) => {
                        const requestMessage = gapi.client.gmail.users.messages.get({
                            'userId': 'me',
                            'id': message.id
                        });

                        requestMessage.execute(getMessage);

                        // let genMsg = genMessage(message);
                        // let msgResponse = genMsg.next();
                        // debugger;
                    });
                })
            }

            function* genMessage(message) {
                const requestMessage = gapi.client.gmail.users.messages.get({
                    'userId': 'me',
                    'id': message.id
                });

                let inboxMessage = yield requestMessage.execute(getMessage);
                console.log(inboxMessage);
            }

            function getMessage(message) {
                let references = message.payload.headers.filter((msg) => {
                    if (msg.name == "References") {
                        return msg.value
                    }
                })[0];
                if (references) {
                    references = references.value;
                    const {allMessages} = _this.state;
                    if (allMessages.length > 0) {
                        const msgObj = allMessages.filter((obj) => {
                            return obj.messageId == references
                        })[0];
                        if (msgObj) {
                            let threadId;
                            if (msgObj.hasOwnProperty('threadId')) {
                                threadId = msgObj.threadId;
                            }
                            else {
                                threadId = message.payload.headers.map((msg) => {
                                    if (msg.name == "References" && msg.value == msgObj.messageId) {
                                        return message.threadId
                                    }
                                }).filter((obj) => {
                                    return obj != undefined
                                })[0];

                                if (threadId != undefined) {
                                    msgObj.threadId = threadId;
                                    HauteFire.addUpdate(msgObj.id, msgObj, "IslandDeals");
                                }
                            }

                            if (threadId != undefined) {
                                if (inboxMessages.length > 0) {
                                    const inbox = inboxMessages.filter((obj) => {
                                        return obj.messageId == msgObj.messageId
                                    })[0];
                                    if (inbox != undefined) {
                                        inboxMessages.push(inbox);
                                    }
                                    else {
                                        inboxMessages.push(msgObj);
                                    }
                                }
                                else {
                                    inboxMessages.push(msgObj);
                                }

                                _this.setAllEmailMessages(inboxMessages);
                                //_this.setState({inboxMessages});
                                //getThreads(threadId);
                            }
                        }
                    }
                }
            }

            function getThreads(threadId) {
                let requestThread = gapi.client.gmail.users.threads.get({
                    'userId': 'me',
                    'id': threadId
                });

                requestThread.execute((response) => {

                })
            }
        })
    }

    getAllMesaages() {
        const _this = this;
        const msgRef = firebase.database().ref("/IslandDeals/");
        msgRef.on('value', (response) => {
            let allMessages = response.val();
            if (allMessages != null) {
                const allKeys = Object.keys(allMessages);
                allMessages = allKeys.map((key) => {
                    return allMessages[key]
                });

                if (allMessages.length > 0) {
                    _this.setState({allMessages});
                }
            }
        })
    }

    showMessage(e) {
        const messageId = e.currentTarget.attributes["data-messageId"].value;
        const threadId = e.currentTarget.attributes["data-threadId"].value;

        if (messageId && threadId != (undefined || null)) {
            this.props.messageDetails({messageId, threadId});
        }
    }

    renderMessages(message) {
        const impClass = message.isImportant ? "fa fa-star color-orange" : "fa fa-star-o";
        const mailDate = new Date(message.id);
        const _date = new Date().toDateString() == mailDate.toDateString() ? mailDate.toLocaleTimeString() : mailDate.toLocaleDateString();

        return (
            <tr className="unread" key={message.id} data-messageId={message.messageId} data-threadId={message.threadId}
                onClick={this.showMessage.bind(this)}>
                <td className="tiny-column">
                    <div className="icheckbox_square-grey"><input className="selected-checkbox" type="checkbox"
                                                                  style={{position: 'absolute', opacity: 0}}/>
                        <ins className="iCheck-helper"
                             style={{
                                 position: 'absolute',
                                 top: 0,
                                 left: 0,
                                 display: 'block',
                                 width: '100%',
                                 height: '100%',
                                 margin: 0,
                                 padding: 0,
                                 background: 'rgb(255, 255, 255)',
                                 border: 0,
                                 opacity: 0
                             }}>
                        </ins>
                    </div>
                </td>
                <td className="tiny-column"><span className="starred"><i className={impClass}></i></span>
                </td>
                <td className="name hidden-xs">{message.islandOwner}</td>
                <td className="subject">{message.subject}</td>
                <td className="tiny-column"><i className="fa fa-paper-clip"></i></td>
                <td className="date">{_date}</td>
            </tr>)
    }

    render() {
        return (
            <div id="mailbox-content" className="mailbox-content">
                <table id="folder-view" className="folder-view table table-striped">

                    <thead>
                    <tr>
                        <th colSpan="3" id="folder-actions">
                            <div className="icheckbox_square-grey"><input id="toggle-all" type="checkbox"
                                                                          style={{position: 'absolute', opacity: 0}}/>
                                <ins className="iCheck-helper"
                                     style={{
                                         position: 'absolute',
                                         top: 0,
                                         left: 0,
                                         display: 'block',
                                         width: '100%',
                                         height: '100%',
                                         margin: 0,
                                         padding: 0,
                                         background: 'rgb(255, 255, 255)',
                                         border: 0,
                                         opacity: 0
                                     }}>
                                </ins>
                            </div>
                            <span className="btn-group">
                                <a className="btn btn-default btn-sm" href="#" data-toggle="dropdown">
                                    Select
                                    <i className="fa fa-angle-down "></i>
                                </a>
                                <ul className="dropdown-menu">
                                    <li><a id="select-all" href="#">All</a></li>
                                    <li><a id="select-none" href="#">None</a></li>
                                    <li className="divider"></li>
                                    <li><a id="select-read" href="#">Read</a></li>
                                    <li><a id="select-unread" href="#">Unread</a></li>
                                </ul>
                            </span>
                        </th>
                        <th colSpan="3" className="total-pages">
                            1-30 of 1,421
                            <button className="btn btn-default btn-xs">
                                <i className="fa fa-angle-left fa-lg"></i>
                            </button>
                            <button className="btn btn-default btn-xs">
                                <i className="fa fa-angle-right fa-lg"></i>
                            </button>
                        </th>
                    </tr>
                    </thead>
                    <tbody>

                    {this.props.allEmailMessages.length > 0 ? this.props.allEmailMessages.map((message) => {
                        return this.renderMessages(message)
                    }) : ""}

                    </tbody>

                </table>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/TestPage/MailList.js